/*
 * A collection of reusable animation functions
 * 
 */

global.GSAP = {
		slideOutLeft:function (options) {
			var object=options.object; 

			var tlMaster = new TimelineMax({paused:true});		
			
			var hideOffset=(-1*(object.offset().left + object.outerWidth()));

			tlMaster.to(
					object,
					options.duration,
					{	
						x:hideOffset 
					}
			);	
			tlMaster.to(
					object,0,
					{
						opacity:0
					}
			);
			return tlMaster;
		},
		slideOutRight:function (options) {
			var object=options.object; 

			var tlMaster = new TimelineMax({paused:true});		
			
			var hideOffset=($( window ).width()-(object.offset().left));

			tlMaster.to(
					object,
					options.duration,
					{	
						x:hideOffset 
					}
			);	
			tlMaster.to(
					object,0,
					{
						opacity:0
					}
			);
			return tlMaster;
		},		
		growElasticOut: function (options) {
			var object=options.object; 

			var tlMaster = new TimelineMax({paused:true});
			
			tlMaster.to(object,2,{	
				scale:1.5, 
				transformOrigin:"50% 50%"
					}
			);
			tlMaster.to(object,2,{	
				scale:0,
				ease: Elastic.easeOut.config(1, 0.3)
					}
			);
			
			return tlMaster;
			
		},		
		
		zoomOut: function (options) {
			var object=options.object; 

			var tlMaster = new TimelineMax({paused:true});

			tlMaster.to(object,options.duration,{	
				scale:0
					}
			);
			
			return tlMaster;
			
		},
		zoomIn: function (options) {
			var object=options.object; 

			var tlMaster = new TimelineMax({paused:true});

			tlMaster.to(object,options.duration,{	
				scale:1
					}
			);
			
			return tlMaster;
			
		},		
		rotate1 :function (options) {
			// a rotating effect
			var object=options.object; 
			var wrap=options.wrap; 

			var tlMaster = new TimelineMax({paused:true, repeat:-1});
	   		var tlY = new TimelineMax({paused:true, repeat:-1});
	    	var tlZ = new TimelineMax({paused:true, repeat:-1});
			
	    	tlMaster.add(tlY.play(),0);
	    	tlMaster.add(tlZ.play(),0);
	    	
	    	otuApp.gsapTLs.push(tlMaster);
					    
			TweenMax.set(wrap, {perspective:400});
		
			tlY.to(object, 8, {ease: Power0.easeNone, rotationY:360});

			tlZ.to(object, 2, {ease: Power0.easeNone, rotationZ:-5});
			tlZ.to(object, 4, {ease: Power0.easeNone, rotationZ:5});
			tlZ.to(object, 2, {ease: Power0.easeNone, rotationZ:0});			
			
			return tlMaster;			
		},		
		wriggle: function (options) {
			// A wriggling effect;
			var object=options.object; 
			var wrap=options.wrap; 

			var tlMaster = new TimelineMax({paused:true, repeat:-1});
	   		var tlY = new TimelineMax({paused:true, repeat:-1});
	    	var tlZ = new TimelineMax({paused:true, repeat:-1});
			
	    	tlMaster.add(tlY.play(),0);
	    	tlMaster.add(tlZ.play(),0);
	    	
	    	otuApp.gsapTLs.push(tlMaster);
					    
			TweenMax.set(wrap, {perspective:400});
		
			tlY.to(object, 0.25, {ease: Power0.easeNone, rotationY:20});
			tlY.to(object, 0.5, {ease: Power0.easeNone, rotationY:-20});
			tlY.to(object, 0.25, {ease: Power0.easeNone, rotationY:0});
			

			tlZ.to(object, 2, {ease: Power0.easeNone, rotationZ:-15});
			tlZ.to(object, 4, {ease: Power0.easeNone, rotationZ:15});
			tlZ.to(object, 2, {ease: Power0.easeNone, rotationZ:0});			
			
			return tlMaster;
		},
		dance: function (options) {
			// A wriggling effect;
			var object=options.object; 
			var wrap=options.wrap; 

			var tlMaster = new TimelineMax({paused:true, repeat:-1});
	   		var tlY = new TimelineMax({paused:true, repeat:-1});
	    	var tlZ = new TimelineMax({paused:true, repeat:-1});
			
	    	tlMaster.add(tlY.play(),0);
	    	tlMaster.add(tlZ.play(),0);
	    	
	    	otuApp.gsapTLs.push(tlMaster);
					    
			TweenMax.set(wrap, {perspective:400});
		
			tlY.to(object, 0.5, {ease: Power0.easeNone, rotationY:20});
			tlY.to(object, 1, {ease: Power0.easeNone, rotationY:-20});
			tlY.to(object, 0.5, {ease: Power0.easeNone, rotationY:0});
			

			tlZ.to(object, 2, {ease: Power0.easeNone, rotationZ:-10});
			tlZ.to(object, 4, {ease: Power0.easeNone, rotationZ:10});
			tlZ.to(object, 2, {ease: Power0.easeNone, rotationZ:0});			
			
			return tlMaster;
		}		
		
}